import _jsx from "@babel/runtime/helpers/jsx";
import React, { memo, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { newPathname } from 'utils';
import { CompanyInfo, CompanyLogoWrapper, CompanyLogo, CompanyData, CompanyDataTitleBlock, CompanyDataTitle, CompanyDataMore, LicenseSpan, RatingValue } from './styles';

function BankCardCompanyInfo(_ref) {
  var logoSquare1x = _ref.logoSquare1x,
      name = _ref.name,
      ratingStability = _ref.ratingStability,
      license = _ref.license,
      slug = _ref.slug;
  var linkToBank = useMemo(function () {
    return newPathname({
      params: {},
      newValues: {
        slug: slug
      }
    });
  }, [slug]);
  return /*#__PURE__*/_jsx(CompanyInfo, {}, void 0, /*#__PURE__*/_jsx(CompanyLogoWrapper, {}, void 0, /*#__PURE__*/_jsx(CompanyLogo, {
    src: logoSquare1x,
    alt: name,
    title: name
  })), /*#__PURE__*/_jsx(CompanyData, {}, void 0, /*#__PURE__*/_jsx(CompanyDataTitleBlock, {}, void 0, /*#__PURE__*/_jsx(CompanyDataTitle, {
    preparedLink: linkToBank
  }, void 0, name)), /*#__PURE__*/_jsx(CompanyDataMore, {}, void 0, !!ratingStability && /*#__PURE__*/_jsx(RatingValue, {
    title: ratingStability,
    totalCount: 5,
    filledCount: ratingStability
  }), !!license && /*#__PURE__*/_jsx(LicenseSpan, {}, void 0, /*#__PURE__*/_jsx(FormattedMessage, {
    id: "card.license",
    values: {
      license: license == null ? void 0 : license.split('№')[1]
    }
  })))));
}

BankCardCompanyInfo.defaultProps = {
  ratingStability: null
};
export default /*#__PURE__*/memo(BankCardCompanyInfo);